<template>
  <div class="form-repeater">
    <div class="form-repeater__items">
      <slot name="items">
        <vue-draggable
          v-model="modelValue"
          item-key="id"
          :disabled="!sortable"
          handle=".form-repeater-item__sort-handle"
        >
          <FormRepeaterItem
            v-for="item in modelValue"
            :key="item.id"
            :model-value="item"
            :inline-fields="inlineFields"
            :sortable="sortable"
            @remove="removeItem">
            <template #default="{ item }">
              <slot name="item" :item="item"></slot>
            </template>
          </FormRepeaterItem>
        </vue-draggable>
      </slot>
    </div>
    <div class="form-repeater__actions" v-if="canAddItem">
      <button
        type="button"
        class="uk-button uk-button-default"
        @click="addItem"
      >
        <slot name="add-item-text">Add Item</slot>
      </button>
    </div>
  </div>
</template>

<script>
import FormRepeaterItem from './FormRepeaterItem.vue'

export default {
  name: 'UiFormRepeater',

  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },

  components: { FormRepeaterItem },

  props: {
    modelValue: {
      type: Array,
      required: true,
    },
    newItemFn: {
      type: Function,
      required: true,
    },
    inlineFields: {
      type: Boolean,
      default: false,
    },
    sortable: {
      type: Boolean,
      default: false,
    },
    maxItems: {
      type: Number,
      default: -1,
    },
  },

  computed: {
    canAddItem() {
      return this.maxItems === -1 || this.modelValue.length < this.maxItems
    },
  },

  watch: {
    modelValue: {
      deep: true,
      handler() {
        this.$emit('update:modelValue', this.modelValue)
      },
    },
  },

  methods: {
    addItem() {
      this.modelValue.push(this.newItemFn())
    },

    removeItem(item) {
      const idx = this.modelValue.findIndex(i => i === item)
      if (idx !== -1) {
        this.modelValue.splice(idx, 1)
      }
    },

    isFirstItem(item) {
      return item === this.modelValue.find(e => true)
    },
  },
}
</script>
